import React, { useState } from "react";
import { phoneDeleteAccount } from "./happyschool_static/happyschoolApi";

const S = {
  page: { background: "#f8fafc", minHeight: "100vh", padding: "0 0 60px", textAlign: "left" },
  hero: {
    background: "linear-gradient(135deg, #0ea5a3 0%, #0f766e 100%)",
    color: "#fff",
    padding: "48px 24px 40px",
    textAlign: "left",
  },
  heroInner: { maxWidth: 780, margin: "0 auto" },
  eyebrow: { fontSize: 13, fontWeight: 700, letterSpacing: 1, opacity: 0.85, textTransform: "uppercase" },
  h1: { fontSize: 30, fontWeight: 800, margin: "8px 0 6px", lineHeight: 1.25 },
  h1Sub: { fontSize: 16, opacity: 0.92, margin: 0 },
  container: { maxWidth: 780, margin: "-24px auto 0", padding: "0 24px" },
  card: {
    background: "#fff",
    borderRadius: 14,
    boxShadow: "0 1px 3px rgba(15,23,42,0.08), 0 8px 24px rgba(15,23,42,0.06)",
    padding: "28px 28px 8px",
    marginBottom: 20,
  },
  section: { marginBottom: 24 },
  sectionHead: { display: "flex", alignItems: "center", gap: 10, marginBottom: 10 },
  icon: { fontSize: 20, lineHeight: 1 },
  h2: { fontSize: 18, fontWeight: 700, color: "#0f172a", margin: 0 },
  p: { fontSize: 15, lineHeight: 1.7, color: "#334155", margin: "0 0 10px" },
  pEn: { fontSize: 14, lineHeight: 1.7, color: "#64748b", margin: "0 0 4px", fontStyle: "italic" },
  ul: { margin: "0 0 10px", paddingLeft: 20 },
  li: { fontSize: 15, lineHeight: 1.7, color: "#334155", marginBottom: 6 },
  divider: { border: "none", borderTop: "1px solid #e2e8f0", margin: "0 0 24px" },
  formCard: {
    background: "#f0fdfa",
    border: "1px solid #99f6e4",
    borderRadius: 12,
    padding: "20px 22px",
    marginBottom: 20,
  },
  label: { display: "block", fontSize: 13, fontWeight: 600, color: "#0f766e", margin: "12px 0 5px" },
  input: {
    width: "100%",
    padding: "10px 12px",
    fontSize: 14,
    border: "1px solid #cbd5e1",
    borderRadius: 8,
    boxSizing: "border-box",
    fontFamily: "inherit",
  },
  select: {
    width: "100%",
    padding: "10px 12px",
    fontSize: 14,
    border: "1px solid #cbd5e1",
    borderRadius: 8,
    boxSizing: "border-box",
    fontFamily: "inherit",
    background: "#fff",
  },
  submitBtn: {
    display: "inline-block",
    marginTop: 16,
    padding: "11px 22px",
    background: "#0ea5a3",
    color: "#fff",
    border: "none",
    borderRadius: 8,
    fontWeight: 700,
    fontSize: 14,
    cursor: "pointer",
    textDecoration: "none",
  },
  submitBtnDisabled: { opacity: 0.55, cursor: "not-allowed" },
  emailBtn: {
    display: "inline-block",
    marginTop: 6,
    padding: "10px 18px",
    background: "#fff",
    color: "#0f766e",
    border: "1px solid #0ea5a3",
    borderRadius: 8,
    fontWeight: 700,
    fontSize: 14,
    textDecoration: "none",
  },
  footerNote: { fontSize: 12, color: "#94a3b8", textAlign: "center", marginTop: 24 },
};

const Section = ({ icon, title, children, last }) => (
  <div style={S.section}>
    <div style={S.sectionHead}>
      <span style={S.icon}>{icon}</span>
      <h2 style={S.h2}>{title}</h2>
    </div>
    {children}
    {!last && <hr style={S.divider} />}
  </div>
);

const SUPPORT_EMAIL = "hoangdung1008@gmail.com";

const DeleteAccount = () => {
  // Xoá thật bằng SĐT + mật khẩu (giống đăng nhập) — dùng cho tài khoản
  // đăng ký bằng SĐT (HappySchool/Quiz3...). Xoá ngay, không cần chờ xử lý tay.
  const [phone, setPhone] = useState("");
  const [password, setPassword] = useState("");
  const [confirmed, setConfirmed] = useState(false);
  const [busy, setBusy] = useState(false);
  const [result, setResult] = useState(null); // { ok, message } | { error }

  const canDelete = phone.trim().length >= 9 && password.length > 0 && confirmed && !busy;

  const doDelete = async () => {
    if (busy) return;
    if (phone.trim().length < 9) { setResult({ error: "Nhập đúng số điện thoại đăng nhập." }); return; }
    if (!password) { setResult({ error: "Nhập mật khẩu." }); return; }
    if (!confirmed) { setResult({ error: "Tích vào ô xác nhận bên trên trước khi xoá." }); return; }
    if (!window.confirm("Xoá tài khoản này? Không thể hoàn tác đăng nhập lại bằng tài khoản này nữa.")) return;
    setBusy(true);
    setResult(null);
    try {
      await phoneDeleteAccount(phone.trim(), password);
      setResult({ ok: true });
    } catch (err) {
      setResult({ error: err.message });
    } finally {
      setBusy(false);
    }
  };

  // Email dự phòng — cho tài khoản không dùng được cách trên (vd quên mật khẩu).
  const [app, setApp] = useState("HappySchool");
  const [identifier, setIdentifier] = useState("");
  const [note, setNote] = useState("");
  const canSubmitEmail = identifier.trim().length > 2;
  const mailtoHref = () => {
    const subject = encodeURIComponent(`[Resshare] Yêu cầu xoá tài khoản — ${app}`);
    const body = encodeURIComponent(
      `Ứng dụng: ${app}\n` +
      `Số điện thoại / Email đăng nhập: ${identifier.trim()}\n` +
      (note.trim() ? `Ghi chú: ${note.trim()}\n` : "") +
      `\nTôi yêu cầu xoá tài khoản và toàn bộ dữ liệu cá nhân liên quan trên ứng dụng Resshare.`
    );
    return `mailto:${SUPPORT_EMAIL}?subject=${subject}&body=${body}`;
  };

  return (
    <div style={S.page}>
      <div style={S.hero}>
        <div style={S.heroInner}>
          <div style={S.eyebrow}>Resshare</div>
          <h1 style={S.h1}>Yêu cầu xoá tài khoản</h1>
          <p style={S.h1Sub}>Account Deletion Request</p>
        </div>
      </div>

      <div style={S.container}>
        <div style={S.card}>
          <Section icon="🗑️" title="Về việc xoá tài khoản">
            <p style={S.p}>
              Ứng dụng <b>Resshare</b> (phát triển bởi <b>Saola Information Technology</b>) cho phép người
              dùng tạo tài khoản để sử dụng các dịch vụ như <b>HappySchool</b> (quản lý trường học)
              và <b>Quiz3</b> (thi trắc nghiệm). Trang này cho phép bạn yêu cầu xoá tài khoản và dữ
              liệu cá nhân liên quan, không cần cài lại hoặc mở ứng dụng.
            </p>
            <p style={S.pEn}>
              Resshare (developed by Saola Information Technology) lets users create an account for services
              such as HappySchool and Quiz3. This page lets you request deletion of your account
              and related personal data, without needing to reinstall or open the app.
            </p>
          </Section>

          <Section icon="📋" title="Dữ liệu sẽ bị xoá / đánh dấu">
            <ul style={S.ul}>
              <li style={S.li}><b>Xoá hẳn, không khôi phục</b>: tài khoản đăng nhập (số điện thoại + mật khẩu).</li>
              <li style={S.li}><b>Đánh dấu đã xoá</b> (giữ lại làm dữ liệu lịch sử, không hiển thị/sử dụng nữa): hồ sơ nhân sự/học sinh, kết quả bài làm, lịch bận đã khai báo.</li>
              <li style={S.li}>Hồ sơ đã đánh dấu xoá sẽ <b>không bao giờ tự động nối lại</b> nếu bạn (hoặc người khác) đăng ký lại đúng số điện thoại đó về sau.</li>
            </ul>
            <p style={S.pEn}>
              Login credentials (phone + password) are permanently deleted. Other related data
              (profile, results, schedules) is flagged as deleted and kept only as historical
              record — it will never be automatically re-linked to a future registration.
            </p>
          </Section>

          <div style={S.section}>
            <div style={S.sectionHead}>
              <span style={S.icon}>🔐</span>
              <h2 style={S.h2}>Xoá ngay bằng số điện thoại + mật khẩu</h2>
            </div>
            <div style={S.formCard}>
              {result && result.ok ? (
                <p style={{ ...S.p, marginBottom: 0, color: "#0f766e", fontWeight: 600 }}>
                  ✅ Đã xoá tài khoản thành công. Bạn không thể đăng nhập lại bằng số điện thoại này nữa.
                </p>
              ) : (
                <>
                  <p style={{ ...S.p, marginBottom: 0 }}>
                    Dùng đúng số điện thoại + mật khẩu bạn dùng để đăng nhập ứng dụng (HappySchool,
                    Quiz3...). Xoá <b>ngay lập tức</b>, không cần chờ xử lý.
                  </p>

                  <label style={S.label}>Số điện thoại đăng nhập *</label>
                  <input
                    style={S.input}
                    value={phone}
                    onChange={(e) => setPhone(e.target.value)}
                    placeholder="VD: 0912345678"
                    inputMode="tel"
                  />

                  <label style={S.label}>Mật khẩu *</label>
                  <input
                    style={S.input}
                    type="password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    placeholder="Mật khẩu đăng nhập"
                  />

                  <label style={{ display: "flex", alignItems: "center", gap: 8, marginTop: 14, fontSize: 13, color: "#334155" }}>
                    <input type="checkbox" checked={confirmed} onChange={(e) => setConfirmed(e.target.checked)} />
                    Tôi hiểu việc xoá tài khoản không thể hoàn tác.
                  </label>

                  {result && result.error && (
                    <p style={{ fontSize: 13, color: "#dc2626", marginTop: 10, marginBottom: 0 }}>{result.error}</p>
                  )}

                  <button
                    type="button"
                    onClick={doDelete}
                    disabled={busy}
                    style={{ ...S.submitBtn, ...(busy ? S.submitBtnDisabled : {}), border: "none" }}
                  >
                    {busy ? "Đang xoá..." : "🗑️ Xoá tài khoản"}
                  </button>
                </>
              )}
            </div>
          </div>

          <div style={{ ...S.section, marginBottom: 0 }}>
            <div style={S.sectionHead}>
              <span style={S.icon}>✉️</span>
              <h2 style={S.h2}>Không xoá được bằng cách trên?</h2>
            </div>
            <div style={S.formCard}>
              <p style={{ ...S.p, marginBottom: 0 }}>
                Điền thông tin bên dưới rồi gửi — chúng tôi xử lý thủ công trong vòng{" "}
                <b>7 ngày làm việc</b>.
              </p>

              <label style={S.label}>Ứng dụng bạn đang dùng</label>
              <select style={S.select} value={app} onChange={(e) => setApp(e.target.value)}>
                <option value="HappySchool">HappySchool</option>
                <option value="Quiz3">Quiz3</option>
                <option value="Khác">Khác / Other</option>
              </select>

              <label style={S.label}>Số điện thoại hoặc email đăng nhập *</label>
              <input
                style={S.input}
                value={identifier}
                onChange={(e) => setIdentifier(e.target.value)}
                placeholder="VD: 0912345678 hoặc ten@gmail.com"
              />

              <label style={S.label}>Ghi chú (không bắt buộc)</label>
              <input
                style={S.input}
                value={note}
                onChange={(e) => setNote(e.target.value)}
                placeholder="Thông tin thêm giúp xác minh tài khoản (nếu có)"
              />

              <a
                href={canSubmitEmail ? mailtoHref() : undefined}
                style={{ ...S.submitBtn, background: "#fff", color: "#0f766e", border: "1px solid #0ea5a3", ...(canSubmitEmail ? {} : S.submitBtnDisabled) }}
                onClick={(e) => { if (!canSubmitEmail) e.preventDefault(); }}
              >
                Gửi yêu cầu xoá tài khoản
              </a>

              <p style={{ ...S.p, marginTop: 16, marginBottom: 0, fontSize: 13, color: "#0f766e" }}>
                Hoặc liên hệ trực tiếp:
              </p>
              <a href={`mailto:${SUPPORT_EMAIL}`} style={S.emailBtn}>✉ {SUPPORT_EMAIL}</a>
            </div>
          </div>
        </div>

        <p style={S.footerNote}>© Resshare — Saola Information Technology</p>
      </div>
    </div>
  );
};

export default DeleteAccount;
